/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Topbar/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import EnvironmentWarning from './EnvironmentWarning/index'
import Inbox from './Inbox/index'
import Logo from './Logo/index'
import Options from './Options/index'
import PatientFlowActions from './PatientFlowActions/index'
import React from 'react'
import SearchInput from './SearchInput/index'
import SupportAuditInfo from './SupportAuditInfo/index'
import Tabs from './Tabs/index'
import Tasks from './Tasks/index'
import Version from './Version/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Topbar({
  children,
  viewPath = "/App/Account/Topbar"
  
}) {
  let isMedia = useIsMedia()
let dtColorsNeutral800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.800'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Topbar.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-Z26QrJi': dtColorsNeutral800}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Topbar.Horizontal:1"
  data-view-path={viewPath}
 style={{'--pt-4-Z26QrJi': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-5-Z26QrJi': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-2-Z26QrJi': isMedia.mobile ? "0px" : typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-Z26QrJi': isMedia.mobile ? "0px" : typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal1}`}
>
<EnvironmentWarning
  viewPath={`${viewPath}/EnvironmentWarning`}
/>
<div
  data-testid="Topbar.Vertical"
  data-view-path={viewPath}
 style={{'--p-6-Z26QrJi': isMedia.mobile ? "absolute" : "relative"}}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={!isMedia.mobile}>
<Logo
  viewPath={`${viewPath}/Logo`}
/>
</fromFlow.When>
<Version
  viewPath={`${viewPath}/Version`}
/>
</div>
<SearchInput
  viewPath={`${viewPath}/SearchInput`}
/>
<Tabs
  viewPath={`${viewPath}/Tabs`}
/>
<PatientFlowActions
  viewPath={`${viewPath}/PatientFlowActions`}
/>
<Tasks
  viewPath={`${viewPath}/Tasks`}
/>
<Inbox
  viewPath={`${viewPath}/Inbox`}
/>
<Options
  viewPath={`${viewPath}/Options`}
/>
<SupportAuditInfo
  viewPath={`${viewPath}/SupportAuditInfo`}
/>
</div>
</div>
{children}
</React.Fragment>)
}